import type { Appointment } from '@/api/appointments/appointmentsApi.types';
import { useSaveAppointmentMutation } from '@/hooks/useSaveAppointmentMutation';

interface ChangeAppointmentStatusVariables {
  appointment: Appointment;
  status: string;
}

export interface ChangeAppointmentStatusMutation {
  changeStatus: (variables: ChangeAppointmentStatusVariables) => Promise<Appointment>;
  isPending: boolean;
}

export function useChangeAppointmentStatusMutation(): ChangeAppointmentStatusMutation {
  const saveMutation = useSaveAppointmentMutation();

  function changeStatus(variables: ChangeAppointmentStatusVariables): Promise<Appointment> {
    const appointment = variables.appointment;
    return saveMutation.mutateAsync({
      appointmentIdentifier: appointment.id,
      appointmentDraft: {
        date: appointment.date,
        startTime: appointment.startTime,
        endTime: appointment.endTime,
        patientId: appointment.patientId,
        therapyType: appointment.therapyType,
        status: variables.status,
        note: appointment.note,
      },
    });
  }

  return { changeStatus, isPending: saveMutation.isPending };
}
